import { DialogCentered } from '../DialogCentered';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useAuthModal } from 'src/hooks/useAuthModal';

export type SignInGuardProps = {
  open: boolean;
  onClose?: () => void;
  onCloseAuth?: () => void;
  title: string;
  description?: string;
};

export const SignInGuard = ({
  onClose = () => {
    /* */
  },
  open: openExternal,
  title,
  description = 'Sign In',
  onCloseAuth,
}: SignInGuardProps) => {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const { openAuthModal } = useAuthModal();

  useEffect(() => {
    setOpen(openExternal);
  }, [openExternal]);

  useEffect(() => {
    if (user) {
      onClose();
    }
  }, [user, onClose]);
  return (
    <DialogCentered open={open} onClose={onClose}>
      <Typography variant="h5" sx={{ px: 4, pb: 4, fontWeight: '500' }}>
        {title}
      </Typography>
      <Button
        onClick={() => {
          openAuthModal(undefined, onCloseAuth);
          setOpen(false);
        }}
        variant="contained"
        size="large"
        fullWidth
        color="primary"
        startIcon={<AccountBalanceWalletOutlinedIcon />}
        sx={{ mt: 4 }}
      >
        {description}
      </Button>
    </DialogCentered>
  );
};
